import BaseService from '@/ecm/common/BaseService.js'
import Utils from '@/ecm/common/Utils.js'

class AutoImportService {
  baseUrl = 'auto-import';
  getOneDriveFolders = (oAuthToken) => BaseService.post({ url: `${this.baseUrl}/onedrive/get-onedrive-folders`, data: oAuthToken });
  getOneDriveToken = (userID) => BaseService.get({ url: `${this.baseUrl}/onedrive/get-token/${userID}` });
  getOneDriveEndpointParameters = () => BaseService.get({ url: `${this.baseUrl}/onedrive/get-endpoint-parameters` });
  getOneDriveFolderSaveConfig = (tokenRefresh) => BaseService.get({ url: `${this.baseUrl}/onedrive/get-folder-config-save/${tokenRefresh}` })
  createFolderOneDrive = (createFolder) => BaseService.post({ url: `${this.baseUrl}/onedrive/create-folder`, data: createFolder })
  checkFolder = (folder) => BaseService.post({ url: `${this.baseUrl}/filesystem/check-folder`, data: folder })
  createFolderFileSystem = (createFolder) => BaseService.post({ url: `${this.baseUrl}/filesystem/create-folder`, data: createFolder })
  getEmailFolders = (credentials) => BaseService.post({ url: `${this.baseUrl}/email/get-email-folders`, data: credentials })
}

export default new AutoImportService()